import React from 'react'
import PropTypes from 'prop-types'

export const Tooltip = ({ title, content }) => (
  <span>
    <wb-tooltip-host position="bottom">
      <span style={{ textDecoration: 'underline dotted' }}>{title}</span>
      <wb-tooltip style={{ backgroundColor: '#ccc' }}>{content}</wb-tooltip>
    </wb-tooltip-host>
  </span>
)

Tooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}
